import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddModal from "../modal/AddModal";
import {
  handleEditOpen,
  handleViewOpen,
  rowValue,
  rowValue1,
} from "../../redux/Reducer/ModalSlice";
import { useDispatch, useSelector } from "react-redux";
import EditModal from "../modal/EditModal";
import VolunteerAdd from "./VolunteerAdd";
import VolunteerEdit from "./VolunteerEdit";
import ViewModal from "../modal/ViewModal";
import VolunteerProfile from "./VolunteerProfile";
import useVolunteerPending from "../../hooks/useVolunteerPending";
import VolunteerFilterNoAdd from "../Others/VolunteerFilterNoAdd";
import moment from "moment";
import Pagination from "../table-components/pagination/Pagination";
import TableComp from "../table-components/table/TableComp";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../Dashboard/Dashboard.style";
const VolunteerPROTable = () => {
  const dispatch = useDispatch();
  const [volunteerPendingInfo, isLoading, isError, error, isSuccess, refetch] =
    useVolunteerPending();

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
    dispatch(rowValue1([]));
  }
  function handleView(rowData) {
    dispatch(handleViewOpen());
    dispatch(rowValue(rowData));
  }

  const handleStatusSubmit = (rowData) => {
    const approved_status = { activeStatus: "1" };

    fetch(
      `${process.env.REACT_APP_API_URL}/api/updateVoluntary/${rowData.vol_no}`,
      {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(approved_status),
      }
    ).then((res) => {
      return res.json();
    });
  };

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "SL No.",
      //   accessor: "index",
      //   Cell: (row) => {
      //     return <div>{Number(row.row.id) + 1}</div>;
      //   },
      //   Filter: false,
      // },
      {
        Header: "Name",
        accessor: "full_name",
        Filter: false,
      },

      {
        Header: "Date of Birth",
        accessor: "dob",
        Cell: (row) => (
          <div>{moment(row.row.original.dob).format("DD MMM YYYY")}</div>
        ),
        Filter: false,
      },
      {
        Header: "Sex",
        accessor: "sex",
        Filter: false,
      },

      {
        Header: "Occupation",
        accessor: "occupation_name",
        Filter: false,
      },

      {
        Header: "Contact Number",
        accessor: "contact_phone",
        Filter: false,
      },
      {
        Header: "Active Status",
        accessor: "active_fg",
        Filter: false,
        Cell: (row) => (
          <div
            style={{
              marginLeft: "15Px",
              display: "flex",
              justifyContent: "start",
              alignItem: "center",
            }}
          >
            {row.row.original.active_fg === "1" ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },

      {
        Header: () => <div style={{ marginLeft: "10px" }}>Action</div>,
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              // style={{}}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update/Approve">
                <EditIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>
            {/* <MouseDiv> */}
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#189A2E" }}
              variant="none"
              onClick={() => handleView(row.row.original)}
            >
              <Tooltip title="Details">
                <VisibilityIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>

            {/* <IconButton onClick={() => handleStatusSubmit(row.row.original)}>
              {row.row.original.approved_status == 1 ? (
                <Tooltip title="Approved">
                  <CheckCircleIcon
                    sx={{
                      color: "#039487",
                    }}
                    // color="success"
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Pending">
                  <PendingIcon />
                </Tooltip>
              )}
            </IconButton> */}
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const add = useSelector((state) => state.Modal.add);
  const edit = useSelector((state) => state.Modal.edit);

  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add]);

  useEffect(() => {
    if (!edit) {
      refetch();
    }
  }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: volunteerPendingInfo },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div>
        <VolunteerFilterNoAdd
          filter={globalFilter}
          setFilter={setGlobalFilter}
        />
      </div>
      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={
              {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "280px",
              }
              // display:"flex",
            }
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
      <AddModal ModalWidth="md" ModalTitle="Add Volunteer Information">
        <VolunteerAdd />
      </AddModal>
      <EditModal ModalWidth="md" ModalTitle="Edit Volunteer Information">
        <VolunteerEdit />
      </EditModal>
      <ViewModal ModalWidth="md" ModalTitle="Volunteer Profile">
        <VolunteerProfile />
      </ViewModal>
    </>
  );
};

export default VolunteerPROTable;
